/**
 * Reconstructs a product object from a Shopify cart line for GA4 tracking
 * @param {Object} cartLine - The cart line node object
 * @returns {Object} Product object compatible with mapProductToGa4Item
 */
export function cartLineToProduct(cartLine) {
  const price = cartLine.merchandise.price?.amount || cartLine.cost?.totalAmount?.amount;
  
  return {
    id: cartLine.merchandise.product?.id,
    title: cartLine.merchandise.product?.title || cartLine.merchandise.title,
    productType: cartLine.merchandise.product?.productType,
    vendor: cartLine.merchandise.product?.vendor,
    variants: {
      edges: [{
        node: {
          sku: cartLine.merchandise.sku,
          price: {
            amount: price
          }
        }
      }]
    },
    priceRange: {
      minVariantPrice: {
        amount: price
      }
    }
  };
}
